import React, { useEffect, useState } from 'react' 
import {useNavigate, Link} from "react-router-dom";
import axios from 'axios';
import Navbar from '../components/Navbar/Navbar.jsx';
const NotFound = (props) => {
    const navigate = useNavigate();
    
    useEffect(() =>{
        setTimeout(() => {
            navigate(-1)
        }, 1500)
    }, [window.location.pathname])

    return (
        <div>
            <h1>404 Page note found</h1>
            <h2>Redirecting to previous page...</h2>
        </div>
    )
}
export default NotFound;
